module.exports = __webpack_public_path__ + "img/Sinnoh.777efb33.png";